import React, { Component } from "react";
import './App.css';
import {BrowserRouter as Router,Route,Routes } from 'react-router-dom';
import Shapp_p1 from './shapp_p1';
import Shapp_p3 from './shapp_p3';
import Login  from './Login';
import LostPassword from './Lost_pw';
import Newuser from './newuser';
import Ticket  from './Ticket';

import Home  from './Home';
import Geoutilities  from './Geoutilities';
import Ves from './ves';
import Digitalservices from './digital_service';
import Elab_serv from './elaboration_services';
import Garage from './garage';
//sezione software saas
import Sw_dash from './software_dash';
import CptElabPanel from './cpt_elaborator'
import SondaggioElabPanel from './sondaggio_elaborator'
import Sw_tutorial from './tutorial'
import Guide from './guide'

import Wms from './WMS';
import Apputils from './app-utils';
import ContactForm from './contact';
import Whoim from './whoim';
import Portfolio from './portfolio';
import Archivio from './archivio';
import Billing from './billing';

import Developing from './Developing';

import Privacy from './privacy';
import Attribution from './attribution';
import Legend from './legend';

import Shapp_OL from './shapp_OLgis';

import jwt_decode from "jwt-decode";

/* ROUTA PROTETTA */
function ProtectedRoute({ isAuthenticated, children }) {
  if (!isAuthenticated) {
    return <Login />;
  }
  return children;
}

class App extends Component {
  state = {
    isAuthenticated: false,
    loading: true,
  };

  componentDidMount() {
    const token = localStorage.getItem("token");

    if (!token) {
      this.setState({
        isAuthenticated: false,
        loading: false,
      });
      return;
    }

    try {
      const decoded = jwt_decode(token);
      const now = Date.now() / 1000;

      this.setState({
        isAuthenticated: decoded.exp > now,
        loading: false,
      });
    } catch (err) {
      console.log("Token non valido");
      this.setState({
        isAuthenticated: false,
        loading: false,
      });
    }
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }

    return (
      <Router>
        <Routes>
          {/* PUBBLICHE */}
          <Route path="/" element={<Home />} />
          <Route path="/discoverves" element={<Ves />} />
          <Route path="/digital_services" element={<Digitalservices />} />
          <Route path="/elaboration_services" element={<Elab_serv />} />
          <Route path="/Geoutilities" element={<Geoutilities />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Lost_pw" element={<LostPassword />} />
          <Route path="/newuser" element={<Newuser />} />
          <Route path="/contatti" element={<ContactForm />} />
          <Route path="/chisono" element={<Whoim />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/attribution" element={<Attribution />} />
          <Route path="/legend" element={<Legend />} />
          <Route path="/developing" element={<Developing />} />

          {/* ACCESSIBILE SEMPRE */}
          <Route path="/GeoData" element={<Shapp_OL />} />

          {/* PROTETTE */}
          <Route
            path="/ves_dashboard"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Garage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/archive"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Archivio />
              </ProtectedRoute>
            }
          />

          <Route
            path="/billing"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Billing />
              </ProtectedRoute>
            }
          />

          <Route
            path="/area_download"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Apputils />
              </ProtectedRoute>
            }
          />

          <Route
            path="/wms"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Wms />
              </ProtectedRoute>
            }
          />

          <Route
            path="/sHapp"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Shapp_p1 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shapp_insdata"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Shapp_p3 />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Ticket"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Ticket />
              </ProtectedRoute>
            }
          />

          <Route
            path="/software"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Sw_dash />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ves_cpt"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <CptElabPanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ves_borehole"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <SondaggioElabPanel />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ves_tutorial"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Sw_tutorial />
              </ProtectedRoute>
            }
          />

          <Route
            path="/guide"
            element={
              <ProtectedRoute isAuthenticated={this.state.isAuthenticated}>
                <Guide />
              </ProtectedRoute>
            }
          />



        </Routes>
      </Router>
    );
  }
}

export default App;